export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="text-lg font-heading font-bold text-background-50">911吃瓜网</span>
            <p className="text-xs md:text-sm text-foreground-300 mt-3 leading-relaxed">
              第一手热门爆料平台，聚焦娱乐八卦、社会热议与网红动态，每天为你呈现最新热点与今日八卦资讯，做最懂吃瓜群众的每日吃瓜实时更新入口。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-xs md:text-sm text-foreground-300 hover:text-primary-300 transition-colors">首页</a></li>
              <li><a href="#topics" className="text-xs md:text-sm text-foreground-300 hover:text-primary-300 transition-colors">热门话题</a></li>
              <li><a href="#updates" className="text-xs md:text-sm text-foreground-300 hover:text-primary-300 transition-colors">最新快讯</a></li>
              <li><a href="#carousel" className="text-xs md:text-sm text-foreground-300 hover:text-primary-300 transition-colors">焦点专题</a></li>
              <li><a href="#faq" className="text-xs md:text-sm text-foreground-300 hover:text-primary-300 transition-colors">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs md:text-sm text-foreground-400">更多合作伙伴即将入驻，敬请期待。</p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-xs md:text-sm text-foreground-300">
                <i className="ri-mail-line text-foreground-400"></i>
                tips@911chigua.com
              </li>
              <li className="flex items-center gap-2 text-xs md:text-sm text-foreground-300">
                <i className="ri-wechat-line text-foreground-400"></i>
                911chigua_official
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 911吃瓜网 - 今日吃瓜今日八卦每日更新
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">关于我们</a>
            <a href="#contact" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">联系我们</a>
            <a href="#faq" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">常见问题</a>
          </div>
        </div>
      </div>
    </footer>
  );
}